import React from 'react'
import Header from './components/header'
import Letter from './components/Letter'
import Bonuses from './components/Bonuses'
import ClinicalStudies from '../../components/Studies'
import LungSolution from './components/LungSolution'
import OffersSection from './components/OfferSection'


const OrderConfirmation = () => {
  return (
    <div className='bg-slate-50'>
      <div>
        <Header />
        <Letter />
      </div>
      <Bonuses />
      <div className='bg-white'>
        <LungSolution />
      </div>
      <OffersSection/>
      <ClinicalStudies />
    </div>
  )
}

export default OrderConfirmation
